import { ReactElement } from 'react'
import { Autocomplete } from 'components/v2/Autocomplete'
import { useQuery } from '@apollo/client'
import { GET_CAMPAIGNS_AUTOCOMPLETE } from 'features/Campaigns/queries-legacy'
import { defineMessages, useIntl } from 'react-intl'
import { ISelectCampaignsProps } from './types'
import { TSelectOption } from 'types/index'

const messages = defineMessages({
  placeholder: {
    id: 'selectCampaigns.autocomplete.placeholder',
    defaultMessage: 'Select a campaign'
  },
  empty: {
    id: 'selectCampaigns.autocomplete.empty',
    defaultMessage: 'No campaings found'
  },
  error: {
    id: 'selectCampaigns.autocomplete.error',
    defaultMessage: 'There was an issue while loading your campaigns'
  }
})

const SelectCampaigns = <TCampaignItem extends TSelectOption>({
  companyId,
  value,
  label,
  getItemLabel,
  onChange,
  campaignTypes,
  errors,
  touched
}: ISelectCampaignsProps<TCampaignItem>): ReactElement => {
  const intl = useIntl()
  const { data, loading, error } = useQuery(GET_CAMPAIGNS_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      input: {
        limit: 1000,
        companyID: companyId || null,
        types: campaignTypes,
        isActive: true
      }
    }
  })
  return (
    <Autocomplete
      placeholder={intl.formatMessage(messages.placeholder)}
      value={value}
      label={label}
      items={data?.campaignsAutocomplete ?? []}
      getItemLabel={(campaign: TCampaignItem): string => (getItemLabel ? getItemLabel(campaign) : `${campaign.name}`)}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={onChange}
      errors={errors}
      touched={touched}
    />
  )
}

export default SelectCampaigns
